import Vue from 'vue';

class Event {

  /**
   * Create a new object instance
   */
  constructor() {
    this.vue = new Vue();
  }

  /**
   * Fire an event
   *
   * @param {string} event
   * @param data
   */
  fire(event, ...data) {
    this.vue.$emit(event, ...data);
  }

  /**
   * Listen to an event
   *
   * @param {string} event
   * @param callback
   */
  listen(event, callback) {
    this.vue.$on(event, callback);
  }

}

export default Event;
